<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24.38" height="15.019" viewBox="0 0 24.38 15.019">
    <g transform="translate(-263.429 -429.548)">
      <g>
        <path
          d="M265.923,444.565a1.422,1.422,0,0,1-.96-.315,1.977,1.977,0,0,1-.416-1.936,2.454,2.454,0,0,0-.379-1.836,2.535,2.535,0,0,1-.437-1.505,24.326,24.326,0,0,0,0-2.519c-.17-.348-.54-1.263-.079-1.866.32-.42.9-.535,1.734-.338.262.062.518.126.765.19,1.948.5,2.834.654,3.385-.885.157-.437.289-.889.414-1.314.387-1.32.668-2.274,1.444-2.37.65-.076,1.185.579,1.63,1.3,1.639.088,5.508,0,6.3-.015a12.057,12.057,0,0,1,3.669-1.557,2.8,2.8,0,0,1,2.543.8,2.258,2.258,0,0,1,.251,2.221c-.636,2-1.449,3.83-4.988,5.949-3.49,2.088-12.271,5.311-13.569,5.734A4.4,4.4,0,0,1,265.923,444.565Zm-1.249-9.41a.394.394,0,0,0-.224.04,1.436,1.436,0,0,0,.219.889l.059.212a26.6,26.6,0,0,1,0,2.738,1.634,1.634,0,0,0,.311.956,3.4,3.4,0,0,1,.493,2.485c-.126.771.029.973.08,1.016.074.064.35.176,1.306-.134,1.283-.418,9.946-3.6,13.365-5.64,3.244-1.943,3.956-3.526,4.549-5.4a1.356,1.356,0,0,0-.077-1.29,1.877,1.877,0,0,0-1.6-.445,11.1,11.1,0,0,0-3.408,1.488l-.119.077h-.142c-.21,0-5.144.129-6.793,0l-.261-.02-.132-.226c-.559-.957-.81-1.042-.821-1.046a9.93,9.93,0,0,0-.568,1.662c-.13.441-.269.913-.432,1.369-.883,2.46-2.761,1.979-4.573,1.515-.242-.061-.491-.125-.746-.185a2.16,2.16,0,0,0-.486-.058Z"
          fill="#777"
        />
        <path
          d="M265.14,441.985l-.224-.975a110.8,110.8,0,0,0,11.536-3.336c3.523-1.477,6.475-3.823,6.991-5.57a8.471,8.471,0,0,1,.8-2.264l.889.461a7.623,7.623,0,0,0-.715,2.041c-.718,2.442-4.334,4.9-7.6,6.265A111.645,111.645,0,0,1,265.14,441.985Z"
          fill="#777"
        />
        <path
          d="M275.952,434.111q-1.244,0-2.468-.109l.088-1a27.1,27.1,0,0,0,4.8,0,.676.676,0,0,1,.076-.026.844.844,0,0,0,.524-1.075V431.9l.944-.331a1.846,1.846,0,0,1-1.13,2.352h0a1.769,1.769,0,0,1-.275.073Q277.217,434.11,275.952,434.111Z"
          fill="#777"
        />
      </g>
      <rect
        width="1"
        height="2.236"
        transform="translate(285.362 433.516) rotate(-63.435)"
        fill="#777"
      />
      <rect
        width="1"
        height="2.236"
        transform="translate(284.362 435.516) rotate(-63.435)"
        fill="#777"
      />
      <rect
        width="1"
        height="2.828"
        transform="translate(282.232 436.422) rotate(-45)"
        fill="#777"
      />
      <rect
        width="1"
        height="2.5"
        transform="matrix(0.8, -0.6, 0.6, 0.8, 280.686, 438.368)"
        fill="#777"
      />
    </g>
  </svg>
</template>
